interface CountryObj {
  Id: string;
  Name: string;
}

interface Region extends CountryObj {
  Countries: CountryObj[];
}

export const findCountryNameById = (countryId: string, regions: Region[], defaultValue: string) => {
  let countryName = "";
  regions?.forEach((region: Region) => {
    region.Countries?.forEach((country: CountryObj) => {
      if (country?.Id == countryId) {
        countryName = country.Name;
      }
    });
  });

  return countryName != "" ? countryName : defaultValue;
};
